import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ViewChild, AfterViewInit, Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/shared/services/api.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDeleteDialogComponent } from 'src/app/shared/confirm-delete-dialog/confirm-delete-dialog.component';

@Component({
  selector: 'app-purchase-order-list',
  templateUrl: './purchase-order-list.component.html',
  styleUrl: './purchase-order-list.component.css',
})
export class PurchaseOrderListComponent implements OnInit, AfterViewInit {
  displayedColumns: string[] = [
    'srNo',
    'poRef',
    'projectName',
    'vendor',
    'source',
    'items',
    'poDate',
    'poStatus',
    'totalValue',
    'action',
  ];

  dataSource = new MatTableDataSource<Record<string, unknown>>([]);
  searchKeyword = '';
  statusFilter = '';
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private apiService: ApiService,
    private toastrMsgService: ToastrMsgService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.fetchData();
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filter = filterValue;
  }

  filterByStatus(event: Event): void {
    this.statusFilter = (event.target as HTMLSelectElement).value;
    this.fetchData();
  }

  fetchData(): void {
    this.apiService.listPurchaseOrders({
      status: this.statusFilter || undefined,
    }).subscribe({
      next: (res: { data?: Record<string, unknown>[] }) => {
        this.dataSource.data = res.data || [];
      },
      error: (err) => {
        this.toastrMsgService.error(err?.error?.message || 'Load failed');
      },
    });
  }

  deleteRecord(item: { id: number; po_ref?: string; po_status?: string }): void {
    const status = String(item.po_status || 'draft').toLowerCase();
    if (!['draft', 'cancelled'].includes(status)) {
      this.toastrMsgService.error('Only draft or cancelled purchase orders can be deleted');
      return;
    }
    const dialogRef = this.dialog.open(ConfirmDeleteDialogComponent, {
      width: '400px',
      data: { itemName: item.po_ref || 'purchase order' },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.apiService.deletePurchaseOrder(item.id).subscribe({
          next: () => {
            this.toastrMsgService.success('Purchase order deleted');
            this.fetchData();
          },
          error: (err) => this.toastrMsgService.error(err?.error?.message || 'Delete failed'),
        });
      }
    });
  }
}
